// Template related mutations
export const SET_TEMPLATES_LOADING = "SET_TEMPLATES_LOADING";
export const SET_TEMPLATES_ERROR = "SET_TEMPLATES_ERROR";
export const SET_SHIPMENT_TEMPLATES = "SET_SHIPMENT_TEMPLATES";
export const SET_BULK_TEMPLATES = "SET_BULK_TEMPLATES";
export const SET_DEAL_TEMPLATES = "SET_DEAL_TEMPLATES";
